import { SubnodeOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation/initYup.ts';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference.ts';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule.ts';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { createCommonFormSchema } from '../../inputs/common/createCommonFormSchema.ts';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema.ts';
import { type IRepeatControllerWidget } from './IRepeatControllerWidget.ts';
import { RepeatControllerWidgetComponent } from './RepeatControllerWidgetComponent.tsx';
import {
  RepeatControllerConfigSchema,
  RepeatControllerWidgetConfigComponent,
} from './RepeatControllerWidgetConfigComponent.tsx';
import { RepeatControllerWidgetPreview } from './RepeatControllerWidgetPreview.tsx';

/**
 * Tipo del componente  contenitore di una lista ripetibile di Widget.
 */
export const RepeatControllerWidgetType: IWidgetType<IRepeatControllerWidget> =
  {
    type: WidgetType.RepeatController,
    mainType: WidgetMainType.Input,
    category: WidgetCategory.Advanced,
    name: 'Controllo Lista Ripetibile',
    icon: <SubnodeOutlined />,
    hasValue: true,
    getReference: getSimpleWidgetReference(Datatype.Number),
    formComponent: RepeatControllerWidgetComponent,
    createFormSchema: ({ widget }) =>
      createCommonFormSchema(
        yup.number().min(0).integer().notRequired(),
        widget,
      ),
    configComponent: RepeatControllerWidgetConfigComponent,
    configValidator: RepeatControllerConfigSchema,
    previewComponent: RepeatControllerWidgetPreview,
    translationSchema: InputCommonTranslationSchema,
    rules: [RequiredRule, CustomWarningsRule],
  };
